<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <span>
                <strong>{{ 'plugins.installationyesno.new-global-answer-option-header' | translate }}</strong>
                <br />
              </span>
              <span>{{ 'plugins.installationyesno.new-global-answer-option-body' | translate }}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="ir-content--modal th-content th-content-customer">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">Apply to all</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <div class="ir-line ir-select th-select" (click)="openApplyAllStatusSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      applyAllStatus && applyAllStatus >= 0
                        ? (applyAllStatus | yesnostatus)
                        : ('plugins.installationyesno.select-status' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="questions"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openQuestionDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationyesno.label' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <input name="Label" class="ir-form-set" type="text" formControlName="Label" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationyesno.status' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="Status" />
                <div class="ir-line ir-select th-select" (click)="openStatusSelector(item.controls.Status.value, i)">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      item.controls.Status.value && item.controls.Status.value >= 0
                        ? (item.controls.Status.value | yesnostatus)
                        : ('plugins.installationyesno.select-status' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectStatusesMenu($event)" (modalClosed)="onClose($event)" #statusesModal></modal>
<confirm
  #questionDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
